var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerminateService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45,
    rx: 22.5,
    stroke: "#F25467",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16V32C8 33.1046 8.89543 34 10 34H31.1716C31.702 34 32.2107 33.7893 32.5858 33.4142L33 33L33.4142 33.4142C33.7893 33.7893 34.298 34 34.8284 34H38C39.1046 34 40 33.1046 40 32V16C40 14.8954 39.1046 14 38 14H34.8284C34.298 14 33.7893 14.2107 33.4142 14.5858L33 15L32.5858 14.5858C32.2107 14.2107 31.702 14 31.1716 14H10C8.89543 14 8 14.8954 8 16Z",
    fill: "#3451D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 15V33",
    stroke: "#1C339B",
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1881 21.875H14.6362C14.4515 21.875 14.2798 21.9702 14.1819 22.1268L13.1171 23.8306C13.0421 23.9505 13.0176 24.0953 13.0489 24.2332L14.1497 29.0767C14.2606 29.5645 14.6943 29.9107 15.1945 29.9107H25.8055C26.3057 29.9107 26.7394 29.5645 26.8503 29.0767L27.9511 24.2332C27.9824 24.0953 27.9579 23.9505 27.8829 23.8306L26.8181 22.1268C26.7202 21.9702 26.5485 21.875 26.3638 21.875H24.8119C24.6288 21.875 24.4583 21.9686 24.36 22.1231L22.8007 24.5733C22.7024 24.7279 22.5319 24.8214 22.3488 24.8214H18.6512C18.4681 24.8214 18.2976 24.7279 18.1993 24.5733L16.64 22.1231C16.5417 21.9686 16.3712 21.875 16.1881 21.875Z",
    fill: "#FFCE51"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3411 25.8828C16.4021 25.7714 16.5622 25.7714 16.6231 25.8828L16.933 26.4495C16.9478 26.4764 16.9699 26.4986 16.9969 26.5134L17.5636 26.8233C17.675 26.8842 17.675 27.0443 17.5636 27.1053L16.9969 27.4152C16.9699 27.43 16.9478 27.4521 16.933 27.4791L16.6231 28.0458C16.5622 28.1572 16.4021 28.1572 16.3411 28.0458L16.0312 27.4791C16.0164 27.4521 15.9943 27.43 15.9673 27.4152L15.4006 27.1053C15.2892 27.0443 15.2892 26.8842 15.4006 26.8233L15.9673 26.5134C15.9943 26.4986 16.0164 26.4764 16.0312 26.4495L16.3411 25.8828Z",
    fill: "#3451D7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3769 25.8828C24.4378 25.7714 24.5979 25.7714 24.6589 25.8828L24.9688 26.4495C24.9835 26.4764 25.0057 26.4986 25.0327 26.5134L25.5993 26.8233C25.7108 26.8842 25.7108 27.0443 25.5993 27.1053L25.0327 27.4152C25.0057 27.43 24.9835 27.4521 24.9688 27.4791L24.6589 28.0458C24.5979 28.1572 24.4378 28.1572 24.3769 28.0458L24.067 27.4791C24.0522 27.4521 24.03 27.43 24.0031 27.4152L23.4364 27.1053C23.3249 27.0443 23.3249 26.8842 23.4364 26.8233L24.0031 26.5134C24.03 26.4986 24.0522 26.4764 24.067 26.4495L24.3769 25.8828Z",
    fill: "#3451D7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.359 17.8477C20.42 17.7362 20.5801 17.7362 20.6411 17.8477L21.6139 19.6264C21.6286 19.6534 21.6508 19.6755 21.6778 19.6903L23.4565 20.6631C23.568 20.7241 23.568 20.8842 23.4565 20.9451L21.6778 21.918C21.6508 21.9327 21.6286 21.9549 21.6139 21.9818L20.6411 23.7606C20.5801 23.8721 20.42 23.8721 20.359 23.7606L19.3862 21.9818C19.3715 21.9549 19.3493 21.9327 19.3223 21.918L17.5436 20.9451C17.4321 20.8842 17.4321 20.7241 17.5436 20.6631L19.3223 19.6903C19.3493 19.6755 19.3715 19.6534 19.3862 19.6264L20.359 17.8477Z",
    fill: "#FFCE51"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.2778,
    y: 4.65039,
    width: 3,
    height: 48,
    transform: "rotate(40 38.2778 4.65039)",
    fill: "#F25467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminateService);
export default __webpack_public_path__ + "static/media/terminate-service.a0b7b238528f3bae3496939d01895b78.svg";
export { ForwardRef as ReactComponent };